import CobeCommunityLayout from "./CobeCommunityLayout";

import { virtualSportRoutes } from "./modules/virtual-sport/routes";

export const cobeCommunityRoutes = {
  path: "cobe-community",
  component: CobeCommunityLayout,
  children: [
    ...virtualSportRoutes(),
  ]
};
